<template>
    <div>
        <div class="hero">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="hero-content">
                            <h1 class="display-4 font-weight-bold  text-white">Billing</h1>
                            <h4 class="font-weight-light  text-white">MANAGE BILLING INFORMATION</h4>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!--Boxes-->
        <div class="boxes-hero">
            <div class="container">
                <div class="row">
                    <div class="col-md-4 my-2">
                        <div class="box shadow-lg bg-white rounded">
                            <div class="box-header bg-light-blue p-3">
                                <div class="row">
                                    <div class="col">
                                        Billing Info
                                    </div>
                                    <b-link
                                            id="edit-billing-link"
                                            @click="toggle_edit_billing_modal">
                                        <span class="icon-blue mx-1"><img src="/icons/icon-edit.png" height="15"></span>
                                    </b-link>
                                </div>
                            </div>
                            <div class="box-body p-3">
                                <div class="row py-2">
                                    <div class="col-md-12">
                                        <b>Credit Card Number</b><br/>{{card_no}}<br/><br/>
                                        <b>Cardholder Name</b><br/>{{model.name}}<br/><br/>
                                        <b>Zip Code</b><br/>{{model.address_zip}}<br/><br/>
                                        <b>Expiration Month / Year</b><br/>{{model.exp_month}}&nbsp;/&nbsp;{{model.exp_year}}<br/><br/>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md" style="background-color: #F2F2F2;;margin: 20px 10px 0px 10px; padding: 15px; font-size: 20px">
                                        <h3>Service Plan Info</h3>
                                        <hr/>
                                        <span style="color: #296a9b; font-weight: bold; font-size: 24px">Basic</span>
                                        <br/><span style="font-weight: bold; font-size:16px;color: #00a716">$107.99/Year or $9.99/Month</span>
                                        <ul style="font-weight: bold; font-size:14px">
                                            <li>1 User</li>
                                            <li>Up to 2 Active Alerts</li>
                                            <li>Annual WaterMetrix™ Reports</li>
                                            <li>App and Dashboard access</li>
                                        </ul>
                                        <hr/>
                                        <span style="color: #296a9b; font-weight: bold; font-size: 24px">Premium</span>
                                        <br/><span style="font-weight: bold; font-size:16px;color: #00a716">$159.99/Year or $14.99/Month</span>
                                        <ul style="font-weight: bold; font-size:14px">
                                            <li>Up to 2 Users</li>
                                            <li>Up to 6 Active Alerts</li>
                                            <li>Flow Rate Information</li>
                                            <li>Remote Valve Control</li>
                                            <li>Quarterly WaterMetrix™ Reports</li>
                                            <li>App and Dashboard Access</li>
                                        </ul>
                                        <hr/>
                                        <span style="color: #296a9b; font-weight: bold; font-size: 24px">Enterprise</span>
                                        <br/><span style="font-weight: bold; font-size:16px;color: #00a716">$479.99/Year or $44.99/Month</span>
                                        <ul style="font-weight: bold; font-size:14px">
                                            <li>Up to 10 Users</li>
                                            <li>Unlimited Active Alerts</li>
                                            <li>Flow Rate Information</li>
                                            <li>Remote Valve Control</li>
                                            <li>Unlimited WaterMetrix™ Reports</li>
                                            <li>App and Dashboard Access</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-8 my-2">
                        <div class="box shadow-lg bg-white rounded">
                            <div class="box-header bg-light-blue rounded-top p-3">
                                <div class="row">
                                    <div class="col">
                                        Service Plans
                                    </div>
                                </div>
                            </div>
                            <div v-for="device in devices" style="margin-top:10px">
                                <div style="font-weight: bold; font-size: 20px;margin-left: 10px">
                                    <router-link style="color: black !important;" :to="`/device/${device.device_id}`">
                                        Device - {{device.device_name}} - {{device.device_imei | lastSix}}
                                    </router-link>
                                </div>
                                <div class="box-body p-3" style="margin-left:20px">
                                    <div v-if="device.service_plan_id">
                                        <div class="row">
                                            <div class="col">
                                                <div v-bind:class="{'price-active':(device.service_plan_id == 1)}" class="shadow-sm rounded px-2 pt-1 mb-4" style="background-color: #F2F2F2;">
                                                    <div class="row">
                                                        <div class="col-md-8">
                                                            <a href="#" v-if="device.service_plan_id != 1" v-on:click="updateServicePlanConfirm(device.device_id,1)" style="font-weight: bold; color: #296a9b"><b>Basic - Monthly</b></a>
                                                            <span v-if="device.service_plan_id == 1"><b>Basic - Monthly</b></span>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div v-bind:class="{'price-active':(device.service_plan_id == 3)}" class="price shadow-sm rounded px-2 pt-1 my-4" style="background-color: #F2F2F2;">
                                                    <div class="row">
                                                        <div class="col-md-8">
                                                            <a href="#" v-if="device.service_plan_id != 3" v-on:click="updateServicePlanConfirm(device.device_id,3)" style="font-weight: bold; color: #296a9b"><b>Premium - Monthly</b>&nbsp</a>
                                                            <span v-if="device.service_plan_id == 3"><b>Premium - Monthly</b></span>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div v-bind:class="{'price-active':(device.service_plan_id == 4)}" class="price shadow-sm rounded px-2 pt-1 my-4" style="background-color: #F2F2F2;">
                                                    <div class="row">
                                                        <div class="col-md-8">
                                                            <a href="#" v-if="device.service_plan_id != 4" v-on:click="updateServicePlanConfirm(device.device_id,4)" style="font-weight: bold; color: #296a9b"><b>Enterprise - Monthly</b></a>
                                                            <span v-if="device.service_plan_id == 4"><b>Enterprise - Monthly</b></span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col">
                                                <div v-bind:class="{'price-active':(device.service_plan_id == 5)}" class="shadow-sm rounded px-2 pt-1 mb-4" style="background-color: #F2F2F2;">
                                                    <div class="row">
                                                        <div class="col-md-8">
                                                            <a href="#" v-if="device.service_plan_id != 5" v-on:click="updateServicePlanConfirm(device.device_id,5)" style="font-weight: bold; color: #296a9b"><b>Basic - Yearly</b></a>
                                                            <span v-if="device.service_plan_id == 5"><b>Basic - Yearly</b></span>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div v-bind:class="{'price-active':(device.service_plan_id == 6)}" class="price shadow-sm rounded px-2 pt-1 my-4" style="background-color: #F2F2F2;">
                                                    <div class="row">
                                                        <div class="col-md-8">
                                                            <a href="#" v-if="device.service_plan_id != 6" v-on:click="updateServicePlanConfirm(device.device_id,6)" style="font-weight: bold; color: #296a9b"><b>Premium - Yearly</b></a>
                                                            <span v-if="device.service_plan_id == 6"><b>Premium - Yearly</b></span>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div v-bind:class="{'price-active':(device.service_plan_id == 7)}" class="price shadow-sm rounded px-2 pt-1 my-4" style="background-color: #F2F2F2;">
                                                    <div class="row">
                                                        <div class="col-md-8">
                                                            <a href="#" v-if="device.service_plan_id != 7" v-on:click="updateServicePlanConfirm(device.device_id,7)" style="font-weight: bold; color: #296a9b"><b>Enterprise - Yearly</b></a>
                                                            <span v-if="device.service_plan_id == 7"><b>Enterprise - Yearly</b></span>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div v-bind:class="{'price-active':(device.service_plan_id == 8)}" class="price shadow-sm rounded px-2 pt-1 my-4" style="background-color: #F2F2F2;">
                                                  <div class="row">
                                                    <div class="col-md-8">
                                                      <b>Demo</b>
                                                    </div>
                                                  </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                    <div v-else>
                                        <b>SUBSCRIBE TO A SERVICE PLAN TO ENABLE THIS DEVICE</b>
                                      <br/><br/>
                                      <div class="row">
                                        <div class="col">
                                          <div class="shadow-sm rounded px-2 pt-1 mb-4" style="background-color: #F2F2F2;">
                                              <div class="row">
                                                  <div class="col-md-8">
                                                      <a href="#" v-on:click="subscribeDevice(device.device_id,1)" style="font-weight: bold; color: #296a9b">Basic - monthly</a>
                                                  </div>
                                              </div>
                                          </div>

                                          <div class="shadow-sm rounded px-2 pt-1 mb-4" style="background-color: #F2F2F2;">
                                              <div class="row">
                                                  <div class="col-md-8">
                                                      <a href="#" v-on:click="subscribeDevice(device.device_id,3)" style="font-weight: bold; color: #296a9b">Premium - monthly</a>
                                                  </div>
                                              </div>
                                          </div>

                                          <div class="shadow-sm rounded px-2 pt-1 mb-4" style="background-color: #F2F2F2;">
                                              <div class="row">
                                                  <div class="col-md-8">
                                                      &nbsp<a href="#" v-on:click="subscribeDevice(device.device_id,4)" style="font-weight: bold; color: #296a9b">Enterprise - monthly</a>
                                                  </div>
                                              </div>
                                          </div>
                                        </div>
                                        <div class="col">
                                          <div class="shadow-sm rounded px-2 pt-1 mb-4" style="background-color: #F2F2F2;">
                                            <div class="row">
                                              <div class="col-md-8">
                                                <a href="#" v-on:click="subscribeDevice(device.device_id,5)" style="font-weight: bold; color: #296a9b">Basic - yearly</a>
                                              </div>
                                            </div>
                                          </div>

                                          <div class="shadow-sm rounded px-2 pt-1 mb-4" style="background-color: #F2F2F2;">
                                            <div class="row">
                                              <div class="col-md-8">
                                                <a href="#" v-on:click="subscribeDevice(device.device_id,6)" style="font-weight: bold; color: #296a9b">Premium - yearly</a>
                                              </div>
                                            </div>
                                          </div>

                                          <div class="shadow-sm rounded px-2 pt-1 mb-4" style="background-color: #F2F2F2;">
                                            <div class="row">
                                              <div class="col-md-8">
                                                <a href="#" v-on:click="subscribeDevice(device.device_id,7)" style="font-weight: bold; color: #296a9b">Enterprise - yearly</a>
                                              </div>
                                            </div>
                                          </div>
                                      </div>
                                      </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <b-modal id="modal-edit-billing" title="Edit Billing Info" size="lg" v-model="modal_edit_billing">
            <template v-slot:modal-header-close>
                <b-button size="sm" class="close" variant="null" @click="toggle_edit_billing_modal">x</b-button>
            </template>

            <h3>Current Card Info</h3>
            <form @submit.prevent="updateCard">
                <b-form-group label="Card Number" label-align-sm="left">
                    <b-form-input type="text" v-model="card_no" :disabled="billingInfo" id="edit-card-last4"/>
                </b-form-group>
                <b-form-group label="Cardholder Name" label-align-sm="left">
                    <b-form-input type="text" id="edit-card-name" v-model="model.name" :placeholder="card_owner"/>
                </b-form-group>
                <b-form-group label="Zip Code" label-align-sm="left">
                    <b-form-input type="text" v-model="model.address_zip" id="edit-card-zip"/>
                </b-form-group>
                <b-form-group label="Expiration Month" label-align-sm="left">
                    <b-form-input type="text" v-model="model.exp_month" id="edit-card-exp-month"/>
                </b-form-group>
                <b-form-group label="Expiration Year" label-align-sm="left">
                    <b-form-input type="text" v-model="model.exp_year" id="edit-card-exp-year"/>
                </b-form-group>
            </form>
            <b-button variant="dark" @click="updateCard"  class="mr-4 my-2"> Update Card Info </b-button>

            <br/><br/><hr/><br/>
            <h3>Replacement Card Info</h3>
              <card  class='stripe-card'
                    :class='{ complete }'
                    :stripe='stripe_pk'
                    :options='stripeOptions'
                    @change='complete = $event.complete'
              /><br/>
            <b-button variant="dark" v-on:click="replaceCard()">Replace Card</b-button>

          <template v-slot:modal-footer="{ ok }">
            &nbsp;
          </template>
        </b-modal>
    </div>
</template>

<script>
    import { Card, createToken } from 'vue-stripe-elements-plus'
    import accountsApi from '../account_apis'
    import devicesApi from '../device_apis'

    const confirmation_box_config = {
        title: 'Confirm Service Plan Change',
        size: 'md',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: 'YES',
        cancelTitle: 'NO',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
    }

    export default {
        name: 'Billing',
        components: { Card },
        props: {
            userData: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                modal_edit_billing: false,
                stripe_pk: process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY,
                showBasicDetails: false,
                showPremiumDetails: false,
                showEnterpriseDetails: false,
                model: {},
                devices: [],
                card_no: null,
                card_owner: null,
                selected: [],
                options: [],
                tabIndex: 0,
                billingInfo: false,
                complete: false,
                stripeOptions: {
                    style: {
                        base: {
                            backgroundcolor: '#303238',
                            fontSize: '16px',
                            color: "#32325d",
                            fontSmoothing: 'antialiased',
                            '::placeholder': {
                                color: 'white',
                            }
                        }
                    }
                }
            }
        },
        created() {
            this.loadCard()
            this.loadDevices()
        },
        filters: {
          lastSix: function(val) {
            val = val.toString()
            return val.toString().substring(val.length - 6, val.length);
          }
        },
        methods: {
            toggle_edit_billing_modal(){ this.modal_edit_billing = !this.modal_edit_billing },

            async subscribeDevice(device_id, plan_id) {
                try {
                    if (confirm('Are you sure you want to subscribe to this plan?')) {
                      this.$emit('showAlert', 'Adding Subscription To Device', 'info')
                      const data = await devicesApi.subscribeDevice({
                        service_plan_id: plan_id,
                        device_id: device_id
                      });
                      if (data.status_code === 200)
                        this.$emit('showAlert', 'Subscription Added To Device', 'success', 1800)

                      this.loadDevices()
                    }
                } catch (e) {
                    e.response && e.response.data && e.response.data.message
                        ? this.alert = {show: true, message: e.response.data.message, variant: 'danger'}
                        : this.alert = {show: true, message: "Device subscription failed", variant: 'danger'}
                }
            },
            async loadCard() {
                try {                    
                    const response = await accountsApi.getBillingInfo(this.userData.accountId)
                    this.model = response.data.card
                    this.model.name = this.model.name? `${this.model.name}` : null
                    this.card_no = `**** **** **** ${this.model.last4} (${this.model.brand})`
                    this.billingInfo = true

                    if(!this.model.name) {
                        this.card_owner = `${this.userData.firstName} ${this.userData.lastName}`
                    }
                } catch (e) {
                    e.response && e.response.data && e.response.data.message
                    ? this.$emit('showAlert', e.response.data.message, 'danger', 5000)
                    : this.$emit('showAlert', 'Cannot load card', 'danger', 5000)
                }
            },
            async loadDevices() {
                const devices = await devicesApi.getDevicePlans(this.userData.accountId)
                this.devices = devices.data

                const plans = (await devicesApi.getPlans()).data
                this.options = plans.map((p) => {
                    return { value: p.id, text: `${p.name} ($${p.price}/month)` }
                })
            },
            async updateCard() {
                console.log("update card")
                try {
                    this.modal_edit_billing = !this.modal_edit_billing
                    this.$emit('showAlert', 'Updating Billing Details', 'info')
                    const data = await accountsApi.updateBillingInfo(this.model.id, this.model)
                    if(data.status_code === 200)
                        this.$emit('showAlert', 'Updated Billing Details', 'success', 1800)
                } 
                catch (e) {
                    e.response && e.response.data && e.response.data.message
                    ? this.$emit('showAlert', e.response.data.message, 'danger', 5000)
                    : this.$emit('showAlert', 'Cannot Update Billing Details', 'danger', 5000)
                }
            },
            async replaceCard() {
              let token
              try {
                const response = await createToken()
                token = response.token.id
                console.log("new token->" + token + " for customer->" + this.model.customer)
                const replace_response = await accountsApi.replaceStripeCard({stripe_token: token, stripe_customer: this.model.customer})
                this.modal_edit_billing = !this.modal_edit_billing
                if(replace_response.status_code === 200)
                  this.$emit('showAlert', 'New Card Saved', 'success', 1800)
                else
                  this.$emit('showAlert', 'Error Updating Card', 'danger', 1800)
                this.loadCard()
              } catch (e) {
                this.$emit('showAlert', 'Error Updating Card', 'danger', 5000)
              }
            },
            async updateDeviceMapping() {
                try {
                    const updated = await devicesApi.updateDevicesSubscription(this.devices)
                    if(updated.status_code === 200) 
                        this.$emit('showAlert', 'Updated device plan', 'success', 1800)
                } 
                catch (e) {
                    e.response && e.response.data && e.response.data.message
                    ? this.$emit('showAlert', e.response.data.message, 'danger', 5000)
                    : this.$emit('showAlert', 'Cannot update device plan', 'danger', 5000)
                }
            },
            async updateServicePlanConfirm(device_id, plan_id) {
                const value = await this.$bvModal.msgBoxConfirm(
                    `Are you sure you want to update this service plan?`,
                    confirmation_box_config
                )
                value ? this.updateServicePlan(device_id, plan_id) : null
            },
            async updateServicePlan(device_id, plan_id) {
                    this.$emit('showAlert', 'Updating Service Plan','info')
                try {
                    for (var i=0; i<this.devices.length; i++)
                    {
                        if (this.devices[i].device_id == device_id)
                            this.devices[i].service_plan_id = plan_id;
                    }

                    const updated = await devicesApi.updateDevicesSubscription(this.devices)
                    if(updated.status_code === 200)
                        this.$emit('showAlert', 'Updated Device Service Plan', 'success', 1800)
                }
                catch (e) {
                    e.response && e.response.data && e.response.data.message
                        ? this.$emit('showAlert', e.response.data.message, 'danger', 5000)
                        : this.$emit('showAlert', 'Cannot Update Device Service Plan', 'danger', 5000)
                }
            }
        }
    }
</script>

<style scoped>
    
    .stripe-card {
        width: 100%;
        background-color: lightgrey;
        border-radius: 0.25rem;
        height: calc(1.5em + 0.75rem + 2px);
        padding: 10px;
    }
</style>
